function formatText(text) {
  const formatted = [];
  text = text.replace(/\n/g, ' \n');

  let counter = 0,
    antiSoftLock = 0;

  function getType(text) {
    const regexp =
      /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

    if (text.length <= 1) return 'text';
    if (text[0] === '#') return 'tag';
    if (text[0] === '@') return 'mention';

    if (regexp.test(text)) return 'url';

    return 'text';
  }

  while (true) {
    let isText =
        text[counter] !== '#' &&
        text[counter] !== '@' &&
        text.slice(counter).indexOf('http://') !== 0 &&
        text.slice(counter).indexOf('https://') !== 0 &&
        text.slice(counter).indexOf('ftp://') !== 0,
      sectionEnd = isText
        ? text.slice(counter).search(/@|#|ftp|http|https/)
        : text.slice(counter).search(' ');

    if (sectionEnd === -1) {
      formatted.push({
        text: text.substring(counter),
        type: getType(text.substring(counter))
      });

      break;
    }

    formatted.push({
      text: text.substr(counter, sectionEnd),
      type: getType(text.substr(counter, sectionEnd))
    });

    counter += sectionEnd;
  }

  return formatted;
}

export default formatText;
